import { Component } from '@angular/core';
import { BikeService2 } from '../../services/bike2.service';

@Component({
    selector   : 'my-bikeModal',
    template: require('./bikeModal.component.html'),
    styles: [require('./bikeModal.component.scss')]
})

export class BikeModalComponent {

    constructor(public bikeService2: BikeService2) {

    }

    toggle(){
        this.bikeService2.isOpen = !this.bikeService2.isOpen;
        if (this.bikeService2.current.notSave) {
            this.bikeService2.functionSave.modelChange();
            return;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/bikeModal/bikeModal.component.ts